// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
  width: 100%;
  max-width: 60dvw;
  margin: 0 auto;
}

.carousel-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60dvh; 
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: scale-down; 
  max-height: 100%; 
}


.modal-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: cover;
  cursor: pointer;
}

.custom-modal-carousel {
  max-width: 90% !important;
  max-height: 90vh !important;
  object-fit: scale-down; 
  max-height: 100%; 
  border-radius: 5px;
  overflow: hidden;
  color: "#af8559";
  padding: 0%;
}

.slick-prev::before, .slick-next::before {
  font-size: 20px; 
  color: transparent; 
}
`, "",{"version":3,"sources":["webpack://./src/components/Carousel/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".carousel-container {\n  width: 100%;\n  max-width: 60dvw;\n  margin: 0 auto;\n}\n\n.carousel-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60dvh; \n}\n\n.carousel-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: scale-down; \n  max-height: 100%; \n}\n\n\n.modal-image {\n  max-width: 100%;\n  max-height: 90vh;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.custom-modal-carousel {\n  max-width: 90% !important;\n  max-height: 90vh !important;\n  object-fit: scale-down; \n  max-height: 100%; \n  border-radius: 5px;\n  overflow: hidden;\n  color: \"#af8559\";\n  padding: 0%;\n}\n\n.slick-prev::before, .slick-next::before {\n  font-size: 20px; \n  color: transparent; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
